module.exports = __webpack_public_path__ + "img/horizontal_6_3_8017.0d7be7db.png";